import {Component, inject, input, OnInit} from '@angular/core'
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn
} from '@angular/forms'
import {MatCheckbox} from '@angular/material/checkbox'
import {
  MatError,
  MatFormField,
  MatLabel,
  MatSuffix
} from '@angular/material/form-field'
import {MatIcon} from '@angular/material/icon'
import {MatInput} from '@angular/material/input'
import {MatOption, MatSelect} from '@angular/material/select'
import {FormatNumberDirective} from '@sparbanken-syd/sparbanken-syd-theme'
import {OrientationService} from '../../../services/orientation.service'
import {RouteService} from '../../../services/route.service'
import {SavingsAccountService} from '../../../services/savings-account.service'

@Component({
  selector: 'spb-savings',
  templateUrl: './savings.component.html',
  styleUrl: '../kyc.component.scss',
  imports: [ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput, MatCheckbox, MatSuffix, FormatNumberDirective, MatIcon, MatSelect, MatOption]
})
export class SavingsComponent implements OnInit {
  public savingsForm = input.required<FormGroup>()

  protected readonly savingsAccountService = inject(SavingsAccountService)
  protected readonly orientationService = inject(OrientationService)
  protected readonly routeService = inject(RouteService)

  protected readonly savingsIntervals = [
    '0 - 50 000',
    '50 000 - 200 000',
    '200 000 - 500 000',
    '500 000 - 1 000 000',
    '1 000 000 - 5 000 000',
    'Mer än 5 000 000'
  ]

  public ngOnInit(): void {
    const sourceControl = this.savingsForm().get('savingsSource')

    if (sourceControl) {
      // Set validator that checks for ACTUAL values (ignoring the initial empty controls)
      sourceControl.setValidators(this.minSelectionValidator)

      // Force an update immediately so the form knows it is INVALID
      // despite the array having a length of 5 (initial empty controls)
      sourceControl.updateValueAndValidity()
    }
  }

  public onCheckboxChange(index: number, checked: boolean) {
    this.savingsAccountService.savingsSource[index].checked = checked

    // Get the actual string values of checked options
    const checkedValues = this.savingsAccountService.savingsSource
      .filter(option => option.checked)
      .map(option => option.value)

    const control = this.savingsForm().get('savingsSource') as FormArray

    // Clear the array (removing the initial empty "ghost" controls)
    // and populate ONLY with selected values
    control.clear()
    checkedValues.forEach(value => control.push(new FormControl(value)))

    control.markAsTouched()
  }

  // Checks if the array contains any TRUTHY values
  private readonly minSelectionValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const values = control.value as any[]

    // .some(v => !!v) returns true if at least one value is not null/undefined/empty
    const hasSelection = Array.isArray(values) && values.some(v => !!v)

    return hasSelection ? null : {required: true}
  }
}